import React, { useState, useEffect } from "react";
import "../style/ChallanForm.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { FaFileAlt } from "react-icons/fa";
import api from "../api/axiosInstance";
import InsertProduct from "./InsertProduct";
import { TokenManager } from "../utils/tokenManager";
import { BASE_URL, API_ENDPOINTS } from "../config/apiconfig";

function ChallanForm() {

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [showInsertProduct, setShowInsertProduct] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [form, setForm] = useState({
    customerId: "",
    challanNumber: "",
    // batchNo: "",
    customer: "",
    challanType: "",
    date: new Date().toISOString().split("T")[0],
    siteLocation: "",
    vehicleNo: "",
    transporter: "",
    driverDetails: "",
    deliveryDetails: "",
    poNo: "",
    depositType: "Deposit",
    depositAmount: "",
    depositNarration: "",
    products: [],
  });

  // Add Products
  const handleProductsAdded = (products) => {

    const mappedProducts = products.map((p) => ({
      name: p.product,
      qty:
        // form.challanType?.includes("Delivered") || !form.challanType
        form.challanType === "DELIVERED" || !form.challanType
          ? Number(p.delivered)
          : Number(p.received),
    }));

    setForm((prev) => ({
      ...prev,
      products: mappedProducts,
    }));

    setShowInsertProduct(false);
    toast.success("Products added successfully!");
  };

  // Fetch existing challan data when in edit mode
  useEffect(() => {
    if (id) {
      // We're in edit mode
      setIsEdit(true);
      fetchChallanData();
    } else {
      // We're in create mode
      setIsEdit(false);
    }

    if (location.state?.products) {
      const mappedProducts = location.state.products.map((p) => ({
        name: p.product,
        qty:
          form.challanType === "DELIVERED" || !form.challanType
            ? Number(p.delivered)
            : Number(p.received),
      }));

      setForm((prev) => ({
        ...prev,
        products: mappedProducts,
      }));
    }
  }, [id, location.state]);

  // Function to fetch existing challan data
  const fetchChallanData = async () => {
    try {
      const token = TokenManager.getToken();
      if (!token) {
        toast.error("Session expired. Please login again.");
        navigate("/");
        return;
      }

      const response = await api.get(`${API_ENDPOINTS.CHALLANS.GET_BY_ID(id)}`);
      if (response.status === 200) {
        const challanData = response.data;
        console.log("Fetched challan data:", challanData);
        
        // Map the API response to form fields
        setForm({
          customerId: challanData.customerId || "",
          challanNumber: challanData.challanNumber || "",
          customer: challanData.customerName || "",
          challanType: challanData.challanType || "",
          date: challanData.date ? challanData.date.split("T")[0] : new Date().toISOString().split("T")[0],
          siteLocation: challanData.siteLocation || "",
          vehicleNo: challanData.vehicleNumber || "",
          transporter: challanData.transporter || "",
          driverDetails: challanData.driverName || "",
          deliveryDetails: challanData.deliveryDetails || "",
          poNo: challanData.purchaseOrderNo || "",
          depositType: challanData.depositeNarration ? "Returned" : "Deposit",
          depositAmount: challanData.depositeAmount || "",
          depositNarration: challanData.depositeNarration || "",
          products: challanData.items ? challanData.items.map(item => ({
            name: item.name,
            qty: item.deliveredQty || item.receivedQty || 0
          })) : []
        });
        
        toast.success("Challan data loaded successfully!");
      } else {
        toast.error("Failed to fetch challan data");
      }
    } catch (error) {
      console.error("Error fetching challan data:", error);
      toast.error("Error loading challan data");
    }
  };

  //   setForm({
  //     ...form,
  //     [name]: value,
  //   });m
  // };
  const handleChange = (e) => {
  const { name, value } = e.target;

  setForm({ 
    ...form,
    [name]: value, 
  });
};
  const handleReset = () => {

    setForm({
      customerId: "",
      challanNumber: "",
      // batchNo: "",
      customer: "",
      challanType: "",
      date: new Date().toISOString().split("T")[0],
      siteLocation: "",
      vehicleNo: "",
      transporter: "",
      driverDetails: "",
      deliveryDetails: "",
      poNo: "",
      depositType: "Deposit",
      depositAmount: "",
      depositNarration: "",
      products: [],
    });

    toast.info("Form reset");
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    console.log("Submit clicked");
    console.log("Form Data:", form);

    if (
      !form.challanNumber ||
      // !form.batchNo ||
      !form.customer ||
      !form.siteLocation ||
      !form.vehicleNo ||
      !form.transporter ||
      !form.challanType
    ) {
      toast.error("Please fill all required fields.");
      return;
    }

    if (form.products.length === 0) {
      toast.error("Please insert products.");
      return;
    }

    try {

      setLoading(true);

      // const token = localStorage.getItem("token");
      // console.log("Token:", token);
        // ✅ FIX: use TokenManager instead of localStorage
const token = TokenManager.getToken();
console.log("Token from TokenManager:", token);

// ✅ safety check (important)
if (!token) {
  toast.error("Session expired. Please login again.");
  navigate("/");
  return;
}
      
const payload = {
  customerId: form.customerId ? Number(form.customerId) : null,
  customerName: form.customer,
  challanNumber: form.challanNumber,
  // batchNo: form.batchNo,
  challanType: form.challanType,
  date: form.date,
  siteLocation: form.siteLocation,
  vehicleNumber: form.vehicleNo,
  transporter: form.transporter,
  driverName: form.driverDetails,
  driverNumber: "", 
  deliveryDetails: form.deliveryDetails,
  purchaseOrderNo: form.poNo,
  depositeNarration: form.depositNarration,
  items: form.products.map((p) => ({
    name: p.name,
    deliveredQty: form.challanType === "DELIVERED" ? Number(p.qty) : 0,
    receivedQty: form.challanType === "RECEIVED" ? Number(p.qty) : 0,
  })),
};

      console.log("Payload:", payload);
      console.log("Request URL:", "https://ctmapi.zerlak.com/api/v1/challans/create");
      console.log("Token:", token);

      // Test if backend is reachable
      try {
        const testResponse = await api.get("/challans/getAllChallan");
        console.log("Backend test successful:", testResponse.data);
      } catch (testError) {
        console.error("Backend not reachable:", testError);
        toast.error("Backend server is not running or not accessible");
        return;
      }

      // Use different API calls for create vs update
      let response;
      if (isEdit) {
        response = await api.put(`${API_ENDPOINTS.CHALLANS.UPDATE(id)}`, payload);
        console.log("Updating challan with ID:", id);
      } else {
        response = await api.post("challans/create", payload);
        console.log("Creating new challan");
      }

      console.log("Response status:", response.status);
      console.log("Response data:", response.data);
      console.log("Response headers:", response.headers);

      if (response.status === 201 || response.status === 200) {
        const successMessage = isEdit ? "Challan Updated Successfully!" : "Challan Saved Successfully!";
        toast.success(successMessage);
        setTimeout(() => {
          navigate("/dashboard/challan");
        }, 1500);
      } else {
        toast.error("Unexpected response status: " + response.status);
      }

    } catch (error) {

      console.error(error);

      if (error.response) {
        toast.error(error.response.data.message || "Failed to create challan");
      } else {
        toast.error("Server not reachable");
      }

    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="cf-container">

      <ToastContainer position="top-right" autoClose={3000} />

      <div className="cf-card"> 

        <div className="cf-header">

          <div className="cf-header-left">
            <FaFileAlt className="cf-icon" />
            <h2>{isEdit ? 'Edit' : 'Delivered / Received'} Challan Entry</h2>
          </div>

        </div>

        <form onSubmit={handleSubmit}>

          <div className="cf-grid">

            <div className="cf-field">
              <label>Challan Number *</label>
              <input
                name="challanNumber"
                value={form.challanNumber}
                onChange={handleChange}
              />
            </div>

            {/* <div className="cf-field">
              <label>Batch No *</label>
              <input
                name="batchNo"
                value={form.batchNo}
                onChange={handleChange}
              />
            </div> */}

            <div className="cf-field full">
              <label>Customer Name *</label>
              <input
                name="customer"
                value={form.customer}
                onChange={handleChange}
              />
            </div>
             <div className="cf-field full">
              <label>Customer ID*</label>
              <input
                name="customerId"
                value={form.customerId}
                onChange={handleChange}
              />
            </div>

            <div className="cf-field">
              <label>Challan Type *</label>
              <select
                name="challanType"
                value={form.challanType}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                <option value="DELIVERED">Delivered</option>
                <option value="RECEIVED">Received</option>
              </select>
            </div>

            <div className="cf-field">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                value={form.date}
                onChange={handleChange}
              />
            </div>

            <div className="cf-field full">
              <label>Site Location *</label>
              <input
                name="siteLocation"
                value={form.siteLocation}
                onChange={handleChange}
              />
            </div>

            <div className="cf-field">
              <label>Vehicle Number *</label>
              <input
                name="vehicleNo"
                value={form.vehicleNo}
                onChange={handleChange}
              />
            </div>

            <div className="cf-field">
              <label>Transporter *</label>
              <input
                name="transporter"
                value={form.transporter}
                onChange={handleChange}
              />
            </div>

            <div className="cf-field full">
              <label>Driver Details</label>
              <input
                name="driverDetails"
                value={form.driverDetails}
                onChange={handleChange}
              />
            </div>

            <div className="cf-field full">
              <label>Delivery Details</label>
              <input
                name="deliveryDetails"
                value={form.deliveryDetails}
                onChange={handleChange}
              />
            </div>

            <div className="cf-field">
              <label>PO No</label>
              <input
                name="poNo"
                value={form.poNo}
                onChange={handleChange}
              />
            </div>

            <div className="cf-field">
              <label>Deposit Amount</label>

              <div className="cf-deposit">

                <select
                  name="depositType"
                  value={form.depositType}
                  onChange={handleChange}
                >
                  <option>Deposit</option>
                  <option>Returned</option>
                </select>

                <input
                  name="depositAmount"
                  value={form.depositAmount}
                  onChange={handleChange}
                  placeholder="0.00"
                />

              </div>

            </div>

            <div className="cf-field full">
              <label>Deposit Narration</label>
              <input
                name="depositNarration"
                value={form.depositNarration}
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="cf-product-btn">

            <button
              type="button"
              className="btn-insert-product"
              onClick={() => setShowInsertProduct(!showInsertProduct)}
            >
              {showInsertProduct ? "Hide Product" : "Insert Product"}
            </button>

          </div>

          {showInsertProduct && (
            <div className="insert-product-inline">
              <InsertProduct
                onProductsAdded={handleProductsAdded}
                onClose={() => setShowInsertProduct(false)}
                isInModal={false}
              />
            </div>
          )}

          <div className="cf-buttons">

            <button
              type="button"
              className="btn-outline"
              onClick={handleReset}
            >
              Reset
            </button>

            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Challan"}
            </button>

          </div>

        </form>

      </div>

    </div>
  );
}

export default ChallanForm;